var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/23d1fe2b451c85a6ea8e80498c280a70.js').default;export default
        Object.assign({}, scope_0 )
    